import { render, staticRenderFns } from "./VlShowFilterItem.vue?vue&type=template&id=e70adb6c&scoped=true&"
import script from "./VlShowFilterItem.vue?vue&type=script&lang=js&"
export * from "./VlShowFilterItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70adb6c",
  null
  
)

export default component.exports